
import { configureStore } from '@reduxjs/toolkit'

import { authSlice } from './auth';
import { publicEventsSlice } from './publicEvents';


export const store = configureStore({
    reducer: {
        auth: authSlice.reducer,
        publicEvents: publicEventsSlice.reducer,
    },


});


export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
